import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { EcoRoutes } from "@tmhcc/eco";

import {
  OktaAuthGuard,
  OktaLoginComponent,
  LogoutComponent
} from "@tmhcc-ng-lib/framwork/okta-login";
import { OktaCallbackComponent } from "@okta/okta-angular";

export function onAuthRequired(oktaAuth, injector) {
  // Redirect the user to your custom login page
  const router = injector.get(Router);
  router.navigate(["/login"]);
}

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "callback", //callback url
        component: OktaCallbackComponent
      },
      {
        path: "logout",
        component: LogoutComponent
      },
      {
        path: "login",
        component: OktaLoginComponent
      },
      ...EcoRoutes,
      { path: "", redirectTo: "knr-dashboard", pathMatch: "full" },
      { path: "**", redirectTo: "knr-dashboard" }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
